<template>
  <SfLoader :class="{ loading }" :loading="loading">
  <div id="product">
    <div class="product">
      <SfGallery
        class="product__gallery"
        :images="product.images || []"
      />
      <div class="product__info">
        <div class="product__header">
          <SfHeading
            :title="product.name"
            :level="3"
            class="sf-heading--no-underline sf-heading--left"
          />
          <SfIcon
            icon="drag"
            size="xl"
            color="gray-secondary"
            class="product__drag-icon smartphone-only"
          />
        </div>
        <div class="product__price-and-rating">
          <SfPrice
            v-if="productPrice(product)"
            :regular="productPrice(product)"
          />
          <div v-else>
            <SfButton  @click="priceCheckModal = true" class="product__add-to-cart" style="margin-top: 0 !important;">
              Уточнить цену
            </SfButton>   
          </div>
           
          
          <div>
            <div class="product__rating">
              <SfRating
                :score="product.rating"
                :max="5" />
              <a
                v-if="!!product.totalReviews"
                href="#"
                class="product__count">
                ({{ product.totalReviews }})
              </a>
            </div>
            <SfButton data-cy="product-btn_read-all" class="sf-button--text desktop-only" @click="changeTab">
              Прочитать все отзывы
            </SfButton>
          </div>
        </div>
        <div>
          <SfProperty
            name="Магазин"
            :value="product.shop.name"
            class="product__property"
          >
            <template #value>
              <router-link :to="{ name: 'shop', params: { shop: product.shop.slug } }">{{ product.shop.name }}</router-link>
            </template>
          </SfProperty>
        </div>
        <div>
          <SfProperty
            name="Телефон"
            :value="getPhone"
            class="product__property"
          >
            <template #value>
              <span
                v-if="!isPhoneClicked"
                class="sf-property__value"
                style="cursor: pointer;"
                @click="isPhoneClicked = true; callShop()"
              >
                +998*********
                <button class="special-button" style=" padding: 5px">Показать номер</button>
              </span>
              <a class="sf-property__value" v-else-if="product.shop.phone" :href="`tel:${product.shop.phone}`">{{product.shop.phone}}</a>
              <span v-else class="sf-property__value">Отсутсвует</span>
            </template>
          </SfProperty>
          <SfProperty
            name="Доставка"
            :value="product.shop.delivery == 1 ? 'Есть' : 'Нет'"
            class="product__property"
          >
          </SfProperty>
        </div>
        <div>
          <SfButton @click="openChat" class="product__add-to-cart">
              Написать
          </SfButton>
          <SfButton data-cy="product-btn_save-later" class="sf-button--text desktop-only product__save">
            В избранное
          </SfButton>
        </div>
        <SfTabs :openTab="Number(openTab)" class="product__tabs">
          <SfTab data-cy="product-tab_description" title="Характеристики">
            <SfProperty
              v-for="property in getProperties"
              :key="property.name"
              :name="property.name"
              :value="property.value"
              class="product__property"
            >
              <template v-if="property.name === 'Category'" #value>
                <SfButton class="product__property__button sf-button--text">
                  {{ property.value }}
                </SfButton>
              </template>
            </SfProperty>
            <h3 v-if="product.description">Описание</h3>
            <div class="description" v-html="product.description"></div>
          </SfTab>
          <SfTab title="Отзывы" data-cy="product-tab_reviews">
            <SfButton class="main-button" @click="openReviewPopup" style="width: 100%; margin-bottom: 30px;">
                Написать отзыв
            </SfButton>
            <SfReview
              v-for="review in product.reviews"
              :key="review.id"
              :author="review.name"
              :message="review.comment || ''"
              :max-rating="5"
              :rating="review.rating"
              :char-limit="250"
              read-more-text="Расширить"
              hide-full-text="Сжать"
              class="product__review"
            />
          </SfTab>
        </SfTabs>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div class="recently">
      <h3 class="sf-heading__title h3">Недавно просмотренное</h3>
      <Swiper
        :auto-update="true"
        :options="{
          slidesPerView: 2,
          spaceBetween: 10,
          loop: true,
          breakpoints: {
            640: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }"
      >
        <SwiperSlide v-for="(product, i) in [...recently, ...popular]" :key="product.id" @click-slide="$router.push({ name: 'product', params: { slug: product.slug } })">
          <Product
            :key="product.slug"
            :product="product"
            :style="{ '--index': i }"
            :isOnWishlist="isOnWishlist"
            @toggleProductWishlist="toggleProductWishlist"
            class="swiper-product"
          />
        </SwiperSlide>
        <div class="swiper-button-prev desktop-only" slot="button-prev"></div>
        <div class="swiper-button-next desktop-only" slot="button-next"></div>
      </Swiper>
    </div>

    <div class="recently" style="margin-top: 60px;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <h3 class="sf-heading__title h3">Популярные</h3>
        <router-link :to="{ name: 'catalog' }">Все</router-link>
      </div>
      <Swiper
        :auto-update="true"
        :options="{
          slidesPerView: 2,
          spaceBetween: 10,
          loop: true,
          breakpoints: {
            640: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }"
      >
        <SwiperSlide v-for="(product, i) in popular" :key="product.id"  @click-slide="$router.push({ name: 'product', params: { slug: product.slug } })">
          <Product
            :key="product.slug"
            :product="product"
            :style="{ '--index': i }"
            :isOnWishlist="isOnWishlist"
            @toggleProductWishlist="toggleProductWishlist"
            class="swiper-product"
          />
        </SwiperSlide>
        <div class="swiper-button-prev desktop-only" slot="button-prev"></div>
        <div class="swiper-button-next desktop-only" slot="button-next"></div>
      </Swiper>
    </div>
    <ReviewPopup :isReviewPopupOpen="isReviewPopupOpen" :shop_id="product.shop.id" @close="isReviewPopupOpen = false; getProduct()" />
    <SfModal :visible="priceCheckModal" overlay title="Выбор" @close="priceCheckModal = false">
      <SfHeading :level="3" title="Выбор" style="margin-bottom: 15px;" />
      <a :href="`tel:${product.shop.phone}`" @click="priceCheckModal = false; callShop()">
        <SfButton class="product__add-to-cart" style="margin-top: 0 !important;">
          Позвонить
        </SfButton>  
      </a>
      <div style="display: flex; width: 100%; justify-content: center; align-items: center; margin: 15px 0;">или</div>
      <SfButton @click="openChat" class="product__add-to-cart" style="margin-top: 0;">
          Написать
      </SfButton>
    </SfModal>
  </div>
  </SfLoader>
</template>
<script>
import axios from 'axios'
import {
  SfProperty,
  SfHeading,
  SfRating,
  SfTabs,
  SfIcon,
  SfReview,
  SfButton,
  SfLoader,
  SfPrice,
  SfModal,
} from '@storefront-ui/vue';

import SfGallery from '../../components/Gallery'

import ReviewPopup from '../../components/ReviewPopup'

import Product from '../../components/Product'

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { createNamespacedHelpers } from 'vuex'
const { mapState: mapAuthState, mapMutations: mapAuthMutations } = createNamespacedHelpers('auth');
const { mapState: mapWLState, mapMutations: mapWLMutations, mapGetters: mapWLGetters } = createNamespacedHelpers('wishlist');

import Talk from "talkjs";

export default {
  name: 'ProductPage',
  components: {
    SfProperty,
    SfHeading,
    SfRating,
    SfTabs,
    SfGallery,
    SfIcon,
    SfReview,
    SfButton,
    SfLoader,
    SfPrice,
    SfModal,
    Swiper, SwiperSlide,
    ReviewPopup,
    Product
  },

  directives: {
    swiper: directive
  },

  data() {
    return {
      product: null,
      openTab: 1,
      popular: [],
      priceCheckModal: false,
      loading: true,
      specifications: {
        metal: {
          "gold": "Золото",
          "white_gold": "Белое золото",
          "yellow_gold": "Желтое золото",
          "red_gold": "Красное золото",
          "combined_gold": "Комбинированное золото",
          "white_platinum": "Белая платина"
        },
        insert: {
          "empty": "Без камня",
          "agate": "Агат",
          "amethyst": "Аметист",
          "beryl": "Берилл",
          "turquoise": "Бирюза",
          "turquoise_them.": "Бирюза им.",
          "diamond": "Бриллиант",
          "refined_diamond": "Бриллиант облагороженный",
          "simplified_cut_diamond": "Бриллиант упрощенной огранки",
          "rhinestone": "Горный хрусталь",
          "garnet": "Гранат",
          "pearl": "Жемчуг",
          "pearl_cult.": "Жемчуг культ.",
          "emerald": "Изумруд",
          "synthetic_emerald": "Изумруд синтетический",
          "iolite": "Иолит",
          "quartz": "Кварц",
          "ceramics": "Керамика",
          "coral": "Коралл",
          "corundum": "Корунд",
          "synthetic_corundum": "Корунд синтетический",
          "larimar": "Ларимар",
          "leucosapphire": "Лейкосапфир",
          "mystic_quartz": "Мистик-кварц",
          "moissanite_synthetic": "Муассанит синтетический",
          "onyx": "Оникс",
          "synthetic_opal": "Опал синтетический",
          "nacre": "Перламутр",
          "rauchtopaz": "Раухтопаз",
          "rhodolite": "Родолит",
          "ruby": "Рубин",
          "ruby glass": "Рубин стекло",
          "synthetic_ruby": "Рубин синтетический",
          "with_stone": "С камнем",
          "sapphire": "Сапфир",
          "diffusion_sapphire": "Сапфир диффузионный",
          "sapphire_synthetic": "Сапфир синтетический",
          "sapphire_colored": "Сапфир цветной",
          "synthetic_insert": "Синтетическая вставка",
          "synthetic_stone": "Синтетический камень",
          "topaz": "Топаз",
          "topaz_london": "Топаз лондон",
          "tourmaline": "Турмалин",
          "cubic_zirconia": "Фианит",
          "chalcedony": "Халцедон",
          "chrysolite": "Хризолит",
          "chrysoprase": "Хризопраз",
          "zircon": "Циркон",
          "citrine": "Цитрин",
          "enamel": "Эмаль",
          "amber": "Янтарь",
          "natural_freshwater_pearls": "Натуральный пресноводный жемчуг"
        },
        insertColor: {
          "empty": "Без вставки",
          "white": "Белый",
          "blue": "Блю",
          "cornflower": "Васильковый",
          "blue_2": "Голубой",
          "smoky": "Дымчатый",
          "yellow": "Желтый",
          "green": "Зеленый",
          "cognac": "Коньячный",
          "brown": "Коричневый",
          "red": "Красный",
          "mystic": "Мистик",
          "orange": "Оранжевый",
          "pink": "Розовый",
          "blue2": "Синий",
          "purple": "Фиолетовый",
          "color": "Цветной",
          "black": "Черный",
          "champagne": "Шампань"
        },
        stoneCut: {
          "empty": "Без огранки",
          "baguette": "Багет",
          "bead": "Бусина",
          "vintage": "Винтаж",
          "faceted": "Граненый",
          "pear": "Груша",
          "emerald": "Изумрудная",
          "square": "Квадрат",
          "round": "Круглая",
          "cushion": "Кушон",
          "marquis": "Маркиз",
          "oval": "Овал",
          "princess": "Принцесса",
          "rectangular": "Прямоугольная",
          "the_rose": "Роза",
          "heart": "Сердце",
          "fantasy": "Фантазийная"
        },
        probe: {
          "375": "375",
          "500": "500",
          "583": "583",
          "585": "585",
          "750": "750",
          "925": "925",
          "950": "950"
        },
        forWho: {
          "womans": "Женщины",
          "mans": "Мужчины",
          "unisex": "Унисекс",
          "youngs": "Подростковый",
          "kids": "Дети"
        },
        style: {
          "vanguard": "Авангард",
          "fishnet": "Ажурные",
          "diamond edge": "Алмазная грань",
          "antique": "Антикварные",
          "butterfly": "Бабочка",
          "bow": "Бантик",
          "infinity": "Бесконечность",
          "wedding": "Венчальное",
          "vintage": "Винтажные",
          "oriental": "Восточные",
          "nut": "Гайка",
          "geometry": "Геометрия",
          "engraving": "Гравировка",
          "double": "Двойные",
          "designer": "Дизайнерские",
          "for_lovers": "Для влюбленных",
          "track": "Дорожка",
          "inflated": "Дутые",
          "animals": "Животные",
          "snake": "Змея",
          "square": "Квадрат",
          "classic": "Классические",
          "classic engagement": "Классические обручальные",
          "crown": "Корона",
          "pigtail": "Косичка",
          "spinning": "Крутящееся",
          "wing": "Крыло",
          "sheet": "Лист",
          "love": "Любовь",
          "raspberry": "Малина",
          "marquise": "Маркиза",
          "massive": "Массивные",
          "soft": "Мягкий",
          "on_foot": "На ногу",
          "typesetting": "Наборное",
          "inscription": "Надпись",
          "fancy": "Необычные",
          "original": "Оригинальные",
          "ring": "Перстень",
          "flat": "Плоское",
          "round": "По кругу",
          "everyday": "Повседневные",
          "engagement": "Помолвочное",
          "the kiss": "Поцелуйчик",
          "princess": "Принцесса",
          "simple": "Простое",
          "heel": "Пяточка",
          "strap": "Ремешок",
          "the_rose": "Роза",
          "rhombus": "Ромб",
          "placer": "Россыпь",
          "wedding2": "Свадебные",
          "traffic lights": "Светофор",
          "heart": "Сердце",
          "vintage2": "Старинные",
          "dancing stone": "Танцующий камень",
          "thick": "Толстые",
          "thin": "Тонкие",
          "trinity": "Тринити",
          "triple": "Тройное",
          "phalanx": "Фаланга",
          "flowers": "Цветы",
          "turban": "Чалма",
          "turtle": "Черепаха",
          "washer": "Шайба",
          "ball": "Шар",
          "balloons": "Шарики",
          "wide": "Широкие",
          "exclusive": "Эксклюзивные",
          "elite": "Элитные"
        },
        type: {
          "like-new": "Как новое",
          "new": "Новое"
        },
        size: {
          "15": "15",
          "16": "16",
          "17": "17",
          "18": "18",
          "19": "19",
          "20": "20",
          "21": "21",
          "22": "22",
          "23": "23",
          "24": "24",
          "13.5": "13.5",
          "14.5": "14.5",
          "15.5": "15.5",
          "16.5": "16.5",
          "17.5": "17.5",
          "18.5": "18.5",
          "19.5": "19.5",
          "20.5": "20.5",
          "21.5": "21.5",
          "22.5": "22.5"
        },
      },
      isModalOpen: false,
      isPhoneClicked: false,
      popup: undefined,
      isReviewPopupOpen: false
    };
  },

  mounted() {
    window.scrollTo(0,0)
    this.getProduct()
  },

  beforeDestroy() {
    if(this.popup) {
      this.popup.destroy()
    }
  },

  computed: {
    ...mapWLGetters({
      isOnWishlist: 'isOnWishlist'
    }),
    ...mapAuthState({
      user: 'user'
    }),
    ...mapWLState({
      recently: 'recently'
    }),
    getProperties() {
      return this.properties.filter((property) => property.value)
    },
    properties() {
      const values = [
        {
          name: 'Метал',
          value: this.specifications.metal[this.product.specification_metal]
        },
        {
          name: 'Вставка',
          value: this.specifications.insert[this.product.specification_insert]
        },
        {
          name: 'Вставка (Второй камень)',
          value: this.specifications.insert[this.product.specification_insert2]
        },
        {
          name: 'Вставка (Третий камень)',
          value: this.specifications.insert[this.product.specification_insert3]
        },
        {
          name: 'Каратность',
          value: this.product.specification_carat
        },
        {
          name: 'Для кого',
          value: this.specifications.forWho[this.product['specification_for-who']]
        },
        {
          name: 'Проба',
          value: this.specifications.probe[this.product.specification_probe]
        },
        {
          name: 'Вес',
          value: this.product.weight || '-'
        }
      ]
      return values.filter((value) => value.value != 0 && value.value != '' && value.value != '0' && value.value != 'Без камня')
    },
    getPhone() {
      return this.isPhoneClicked ? (this.product.shop.phone || 'Отсутвует') : 'ПОЛУЧИТЬ НОМЕР'
    },
  },

  beforeRouteUpdate(to, from, next) {
    window.scrollTo(0 ,0)
    this.loading = true
    this.getProduct(to.params.slug)
      .then(() => {
        window.scrollTo(0 ,0)
        this.loading = false
      })
    next()
  },

  methods: {
    ...mapWLMutations({
      addRecently: 'ADD_RECENTLY',
      toggleProductWishlist: 'ADD_PRODUCT'
    }),
    ...mapAuthMutations({
      toggleAuthModal: 'TOGGLE_MODAL'
    }),
    async getProduct(slugOpt = null) {
      const slug = slugOpt ? slugOpt : this.$route.params.slug

      await axios.get(`${process.env.VUE_APP_API_URL}/product/${slug}`)
        .then((result) => {
          const data = result.data.product;

          document.title = `${data.name} - CityGold.uz`
          document.querySelector('meta[name="description"]').setAttribute("content", data.description);
          document.querySelector('meta[property="og:image"]').setAttribute("content", `${process.env.VUE_APP_STORAGE}/${data.image}`);

          this.popular = result.data.popular;

          this.addRecently(data)
          let images = JSON.parse(data.images);
          if(images) {
            images = images.map((image) => {
              return {
                "alt": "Product A",
                "mobile": {
                  "url": `${process.env.VUE_APP_STORAGE}/${image}`
                },
                "desktop": {
                  "url": `${process.env.VUE_APP_STORAGE}/${image}`
                },
                "zoom": {
                  "url": `${process.env.VUE_APP_STORAGE}/${image}`
                }
              }
            })
            data.images = [
              {
                "alt": "Product A",
                "mobile": {
                  "url": `${process.env.VUE_APP_STORAGE}/${data.image}`
                },
                "desktop": {
                  "url": `${process.env.VUE_APP_STORAGE}/${data.image}`
                },
                "zoom": {
                  "url": `${process.env.VUE_APP_STORAGE}/${data.image}`
                }
              },
              ...images
            ];
          } else {
            data.images = [
              {
                "alt": "Product A",
                "mobile": {
                  "url": `${process.env.VUE_APP_STORAGE}/${data.image}`
                },
                "desktop": {
                  "url": `${process.env.VUE_APP_STORAGE}/${data.image}`
                },
                "zoom": {
                  "url": `${process.env.VUE_APP_STORAGE}/${data.image}`
                }
              }
            ];
          }
          

          this.product = data;
          this.loading = false;

          axios.post(`${process.env.VUE_APP_API_URL}/analytics/${this.product.shop.id}`, {
            field: 'visits_total'
          })

          setTimeout(() => {
            axios.post(`${process.env.VUE_APP_API_URL}/analytics/${this.product.shop.id}`, {
              field: 'views_products'
            })
            axios.post(`${process.env.VUE_APP_API_URL}/category_analytics/${this.product.shop.slug}`, {
              category_id: this.product.category_id
            })
          }, 2000)

          let uniqueShops = localStorage.getItem('uniqueShops')
          const productShopId = this.product.shop.id

          if(uniqueShops) {
            uniqueShops = JSON.parse(uniqueShops)
            console.log(uniqueShops)

            if(!uniqueShops.includes(productShopId)) {
              uniqueShops.push(productShopId)
              localStorage.setItem('uniqueShops', JSON.stringify(uniqueShops))
              axios.post(`${process.env.VUE_APP_API_URL}/analytics/${productShopId}`, {
                field: 'visits_unique'
              })
            }
          } else {
            uniqueShops = []

            uniqueShops.push(productShopId)
            localStorage.setItem('uniqueShops', JSON.stringify(uniqueShops))
            axios.post(`${process.env.VUE_APP_API_URL}/analytics/${productShopId}`, {
              field: 'visits_unique'
            })

          }
        })
    },
    callShop() {
      axios.post(`${process.env.VUE_APP_API_URL}/analytics/${this.product.shop.id}`, {
        field: 'actions_call'
      })
    },
    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },

    getMinimalImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },

    changeTab() {
      this.openTab = 2;
    },

    chatOpen() {
      axios.post(`${process.env.VUE_APP_API_URL}/analytics/${this.product.shop.id}`, {
        field: 'actions_write'
      })
      Talk.ready
        .then(() => {
          const user = this.user
          const product = this.product
          const seller = this.product.shop.seller
          const me = new Talk.User({
              id: user.id,
              name: user.name,
              email: user.email,
              phone: user.phone,
              locale: 'ru-RU',
              role: 'buyer',
              photoUrl: `${process.env.VUE_APP_STORAGE}/${user.avatar}`,
              welcomeMessage: `Продукт - ${product.name} (${product.id})`
          });

          const session = new Talk.Session({
              appId: "tgD9HNRx",
              me: me
          });

          session.setDesktopNotificationEnabled(true)

          const other = new Talk.User({
              id: seller.id,
              name: this.product.shop.name,
              email: seller.email,
              phone: seller.phone,
              locale: 'ru-RU',
              role: 'employee',
              photoUrl: `${process.env.VUE_APP_STORAGE}/${seller.avatar}`,
          });

          const conversation = session.getOrCreateConversation(Talk.oneOnOneId(me, other));
          conversation.setParticipant(me);
          conversation.setParticipant(other);

          axios.defaults.headers.common = {'Authorization': `Bearer sk_test_CPPkS8pOFZVIeF9Q2h08s8yXxw3k8dsR`}

          axios.post(`https://api.talkjs.com/v1/tgD9HNRx/conversations/${conversation.id}/messages`, [
            {
              text: `Продукт - ${product.name} (${product.id}) - https://citygold.uz/product/${product.slug}`,
              sender: String(me.id),
              type: "UserMessage"
            },
          ])
          this.popup = session.createPopup(conversation, { keepOpen: false, messageField: { placeholder: 'Напишите своему продавцу...' } });
          this.popup.mount();  
        })
        .catch(error => console.log(error)) 
    },

    openChat() {
      if(!this.user) {
        this.toggleAuthModal(false)
      }
      if(this.popup) {
        this.popup.destroy()
      }
      this.chatOpen()
    },
    openReviewPopup() {
      if(!this.user) {
        this.toggleAuthModal(false)
      } else {
        this.isReviewPopupOpen = true;
      }
      
    },
    productPrice(product) {
      let price = 0;
      // Fonon
      if(product.shop.id === 22) {
        if(product.price) {
          price = product.price
        } else if(product.weight && (product.specification_insert == 'empty' && product.specification_insert2 == 'empty'  && product.specification_insert3 == 'empty')) {
          if(product.specification_probe == 583 || product.specification_probe == 585) {
            price = product.weight * product.shop.probe_583_price
          } else if(product.specification_probe == 750) {
            price = product.weight * product.shop.probe_750_price
          }
        }
      }
      // jeWell
      else if(product.shop.id === 21 || product.shop.id === 19) {
        price = 10581 * product.price
      } else {
        price = product.price
      }

      if(price) {
        return Intl.NumberFormat('uz-UZ', { minimumFractionDigits: 0 }).format(price) + ' сум'
      } else return ''
    }
  }
};
</script>

<style lang="scss" scoped>
#product {
  box-sizing: border-box;
  padding: 0 var(--spacer-sm);
  @include for-desktop {
    max-width: 1272px;
    padding: 0;
    margin: 0 auto;
  }
}
.product {
  @include for-desktop {
    display: flex;
  }
  &__info {
    margin: var(--spacer-sm) auto var(--spacer-xs);
    @include for-desktop {
      max-width: 32.625rem;
      margin: 0 0 0 7.5rem;
      width: 100%;
    }
  }
  &__header {
    --heading-title-color: var(--c-link);
    margin: 0 var(--spacer-sm);
    display: flex;
    justify-content: space-between;
    @include for-desktop {
      margin: 0 auto;
    }
  }
  &__drag-icon {
    animation: moveicon 1s ease-in-out infinite;
  }
  &__price-and-rating {
    margin: var(--spacer-xs) var(--spacer-sm) var(--spacer-base);
    align-items: center;
    @include for-desktop {
      display: flex;
      justify-content: space-between;
      margin: var(--spacer-sm) 0 var(--spacer-lg) 0;
    }
  }
  &__rating {
    display: flex;
    align-items: center;
    margin: var(--spacer-xs) 0;
    @include for-desktop {
      justify-content: flex-end;
    }
  }
  &__count {
    @include font(
      --count-font,
      var(--weight--normal),
      var(--font-size--sm),
      1.4,
      var(--font-family--secondary)
    );
    color: var(--c-text);
    text-decoration: none;
    margin: 0 0 0 var(--spacer-xs);
  }
  &__description {
    color: var(--c-link);
    margin-top: var(--spacer-xl);
    @include font(
      --product-description-font,
      var(--font-weight--normal),
      var(--font-size--base),
      1.6,
      var(--font-family--primary)
    );
  }
  &__select-size {
    margin: 0 var(--spacer-sm);
    @include for-desktop {
      margin: 0;
    }
  }
  &__colors {
    @include font(
      --product-color-font,
      var(--font-weight--normal),
      var(--font-size--lg),
      1.6,
      var(--font-family--secondary)
    );
    display: flex;
    align-items: center;
    margin-top: var(--spacer-xl);
  }
  &__color-label {
    margin: 0 var(--spacer-lg) 0 0;
  }
  &__color {
    margin: 0 var(--spacer-2xs);
  }
  &__add-to-cart {
    margin: var(--spacer-base) var(--spacer-sm) 0;
    width: 100%;
    margin-left: 0;
    @include for-desktop {
      margin: var(--spacer-2xl) 0 0 0;
    }
  }
  &__guide,
  &__compare,
  &__save {
    display: block;
    margin: var(--spacer-xl) 0 var(--spacer-base) auto;
  }
  &__compare {
    margin-top: 0;
  }
  &__tabs {
    margin: var(--spacer-lg) auto var(--spacer-2xl);
    @include for-desktop {
      margin-top: var(--spacer-2xl) 0 0 0;
      --tabs-content-tab-padding: 3.5rem 0 0 0;
    }
  }
  &__property {
    margin: var(--spacer-base) 0;
    &__button {
      --button-font-size: var(--font-size--base);
    }
  }
  &__review {
    padding-bottom: 24px;
    border-bottom: var(--c-light) solid 1px;
    margin-bottom: var(--spacer-base);
    &:last-of-type {
      border: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
    @include for-desktop {
      padding-bottom: 0;
    }
  }
  &__additional-info {
    @include font(
      --additional-info-font,
      var(--font-weight--light),
      var(--font-size--base),
      1.6,
      var(--font-family--primary)
    );
    &__title {
      color: var(--c-link);
      font-weight: var(--font-weight--bold);
      margin: 0 0 var(--spacer-sm);
      &:not(:first-child) {
        margin-top: 3.5rem;
      }
    }
    &__paragraph {
      margin: 0;
    }
  }
  &__gallery {
    flex: 1;
  }
}
.breadcrumbs {
  margin: var(--spacer-base) auto var(--spacer-lg);
}
@keyframes moveicon {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 30%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}

.product__product-card {
  max-width: 100%;
}
</style>

<style lang="scss">
.glide__slide a:hover {
  background: none;

}

.products {
  box-sizing: border-box;
  flex: 1;
  margin: 0;
  &__grid,
  &__list {
    display: flex;
    flex-wrap: wrap;
  }
  &__product-card {

  }
  &__product-card-horizontal {
    flex: 0 0 100%;
  }
  &__slide-enter {
    opacity: 0;
    transform: scale(0.5);
  }
  &__slide-enter-active {
    transition: all 0.2s ease;
    transition-delay: calc(0.1s * var(--index));
  }
  @include for-desktop {
    &__grid {
      margin: var(--spacer-sm) 0 0 0;
    }
    &__pagination {
      display: flex;
      justify-content: flex-start;
      margin: var(--spacer-xl) 0 0 0;
    }
    &__product-card-horizontal {
      margin: var(--spacer-lg) 0;
    }
    &__product-card {
      flex: 1 1 25%;
    }
    &__list {
      margin: 0 0 0 var(--spacer-sm);
    }
  }
  &__show-on-page {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    &__label {
      font-family: var(--font-family--secondary);
      font-size: var(--font-size--sm);
    }
  }
}

.swiper-button-prev, .swiper-button-next {
      color: #f7cc41;
}

.main-button {
  &:active {
    --button-background: var(--c-primary) !important;
  }
}

.swiper-slide {
  .products__product-card {
    max-width: 100% !important;
    flex: 1 !important;
  }
}
</style>
